import React, { Component } from "react"
import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    PostalCodeElement,
} from "react-stripe-elements"
import CountrySelector from "./country_selector"

const CARD_HOLDER_LABEL = "Name on card"
const CARD_NUMBER_LABEL = "Card number"
const CARD_EXPIRATION_LABEL = "Expiration"
const CARD_CVC_LABEL = "CVC"
const CARD_POSTAL_CODE_LABEL = "Postal code"

class BillingInfoForm extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { handleSetName, isNameValid } = this.props
        const renderErrorNameInputText = isNameValid ? "" : "error-text"

        return (
            <div className="billing-info-container billing-info-section">
                <label className="billing-info-label">{CARD_HOLDER_LABEL}</label>
                <input
                    className={`billing-info-input form-control ${renderErrorNameInputText}`}
                    type="text"
                    onBlur={handleSetName}
                />
                <label className="billing-info-label">{CARD_NUMBER_LABEL}</label>
                <CardNumberElement className="billing-info-input form-control" />
                <div className="billing-info-two-columns">
                    <div className="billing-info-col col-1">
                        <label className="billing-info-label">{CARD_EXPIRATION_LABEL}</label>
                        <CardExpiryElement className="billing-info-input form-control" />
                    </div>
                    <div className="billing-info-col">
                        <label className="billing-info-label">{CARD_CVC_LABEL}</label>
                        <CardCVCElement className="billing-info-input form-control" />
                    </div>
                </div>
                <CountrySelector />
                <label className="billing-info-label">{CARD_POSTAL_CODE_LABEL}</label>
                <PostalCodeElement className="billing-info-input form-control" />
            </div>
        )
    }
}

export default BillingInfoForm



// WEBPACK FOOTER //
// ./src/components/billing_info_form.jsx